module.exports = __webpack_public_path__ + "static/media/Behar y cia .620d6fb6.png";